import { toastr } from "react-redux-toastr";
import React, { PureComponent } from "react";
import Images from "../../Assets/Images";
import Api from "../../Services/Api";
import { Dropdown } from 'react-bootstrap';
export default class DashboardTextNarrative extends PureComponent {
    constructor(props) {
        super(props);
    this.state = {     
        textNarrative: this.props.chartInputs.textNarrative
    };
    }
    temp  (val){
        this.setState({
          ...this.state,
          textNarrative :val,
          count : 1
        })
      }
      temp1  (val){
        this.setState({
          ...this.state,
          textNarrative :val,
          count : 1
        })
      }
      saveDescription  = async (dashBoardId) => {
        try {
          const requestParams = {
            TextNarrative : this.state.textNarrative,
            dashBoardId: dashBoardId,
          };
          this.setState({ ...this.state, loader: true });
          let response = await Api.dashboardTextNarrative(requestParams);
          if (response.status === 200) {
            this.setState({ ...this.state, loader: false });
            toastr.success(response.message);
            this.closeWidgetDeletePopup();
            this.props.selectedDB();
          } else {
            this.setState({ ...this.state, loader: false });
            toastr.error(response.message);
          }
        } catch (error) {
          console.error(error);
          this.setState({ ...this.state, loader: false });
        }
      }
      render() {
        const chartData = this.props.chartInputs ? this.props.chartInputs : {};
        if(this.state.count == 0){
            this.temp1(chartData.textNarrative);
        }
        return (<li>
            <Dropdown
              menuAlign="right"
              title="Text Narrative"
              id="dropdown-menu-align-right"
            >
              <Dropdown.Toggle>
                <a>
                {this.state.textNarrative ?(
                    <img src={Images.BLUETEXT} alt="Share" width="14" />
                  ):(<img src={Images.TEXT} alt="Share" width="14" />)}
                </a>
              </Dropdown.Toggle>
              <Dropdown.Menu className="filterList emailBox">
                <div className="filterBox">
                  <div className="dateRange">                     
                    <div className="dateCont">
                      <h6>Text Narrative</h6>
                      <textarea
                        value={this.state.textNarrative}
                        onChange={(e) =>
                          this.temp(e.target.value)
                        }
                        autoComplete="off"
                      ></textarea>
                      <Dropdown.Item
                        as="button"
                       onClick={() => this.saveDescription(chartData.dashboardId)}
                      >
                        Submit
                      </Dropdown.Item>
                    </div>
                  </div>
                </div>
              </Dropdown.Menu>
            </Dropdown>
          </li>)
      }
}